import { useState, React, useRef, useEffect } from "react";
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch, useLocation, useHistory } from "react-router-dom";

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import routes from "routes.js";

import { useIdleTimer } from "react-idle-timer";
import { MainContext } from "context/MainContext";
import { logout } from "components/Services/authService";

var ps;

function Admin(props) {
  const location = useLocation();
  const [sidebarMini, setSidebarMini] = useState(false);
  const [title, setTitle] = useState("");
  const mainPanel = useRef();
  const history = useHistory();
  const [privileges, setPrivileges] = useState(null);
  const [remaining, setRemaining] = useState(0);

  const sessionDuration = Number(
    sessionStorage.getItem("sessionDuration") ?? 0,
  );

  useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(mainPanel.current);
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
        document.documentElement.className += " perfect-scrollbar-off";
        document.documentElement.classList.remove("perfect-scrollbar-on");
      }
    };
  });

  const onIdle = () => {
    if (sessionDuration > 0) {
      const location = {
        pathname: "/auth/login",
      };
      history.push(location);
    }
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    timeout: sessionDuration == 0 ? 2000000000 : sessionDuration,
    throttle: 1000,
  });

  useEffect(() => {
    fetchPrivileges();

    if (sessionDuration > 0) {
      const interval = setInterval(() => {
        setRemaining(Math.ceil(getRemainingTime() / 1000));
      }, 5000);

      return () => {
        clearInterval(interval);
      };
    }
  }, []);

  const fetchPrivileges = () => {
    fetch("/api/v1/setting/privileges", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            logout();
          }
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((actualData) => {
        setPrivileges(actualData.data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainPanel.current.scrollTop = 0;
  }, [location.pathname, location.state?.forceRefresh]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }

      if (prop.layout === "/admin") {
        return (
          <Route
            exact
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const handleMiniClick = () => {
    if (document.body.classList.contains("sidebar-mini")) {
      setSidebarMini(false);
    } else {
      setSidebarMini(true);
    }

    document.body.classList.toggle("sidebar-mini");
  };

  return (
    <div className="wrapper">
      {privileges ? (
        <>
          <MainContext.Provider value={privileges}>
            <Sidebar
              {...props}
              handleMiniClick={handleMiniClick}
              sidebarMini={sidebarMini}
              routes={routes}
            />
            <div className="main-panel" ref={mainPanel}>
              <div
                className="responsive-scroll-wrapper"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: "100vh",
                }}
              >
                <AdminNavbar {...props} title={title} />

                <div style={{ padding: "0 20px", flex: "1 0 auto" }}>
                  {" "}
                  <Switch key={location.state?.forceRefresh || 0}>
                    {getRoutes(routes)}
                  </Switch>
                </div>

                {props.location.pathname.indexOf("full-screen-map") !==
                -1 ? null : (
                  <Footer fluid />
                )}
              </div>
            </div>
          </MainContext.Provider>
        </>
      ) : (
        <div className="main-panel" ref={mainPanel}></div>
      )}
    </div>
  );
}

export default Admin;
